<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div style="padding: 6px;">统计</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body"  style="max-height: 300px;padding: 10px;">

        <div v-for="(value,i) in tableData" :key="i" style="padding: 10px">
          名称：{{value.name}}

          <div v-for="(value,i) in value.arr" :key="i" style="padding: 10px;">
            标题：{{value.name}}

            <div v-for="(value,i) in value.arr" :key="i" >
              回答：{{value.name}}({{value.count}})
            </div>

          </div>


        </div>


      </div>
<!--      <div class="modal-footer">-->
<!--        <el-button @click.native="closeSelf">取消</el-button>-->
<!--        <el-button :loading="loading" type="primary" @click.native="confirm">提交</el-button>-->
<!--      </div>-->
    </div>

  </div>
</template>


<script>

import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";

export default {
  name: 'Add',
  props: [],
  data() {
    return {

      loading: false,

      tableData:[],

    }
  },
  methods: {
    init(askAnswerRecordCode){

      this.getTotal(askAnswerRecordCode);

    },
    closeSelf() {
      this.$emit("closeAll");
    },

    getTotal(code){

      this.$axios({
        method: 'post',
        url: this.$shopUrl+'AskAnswerRecordSite/Total',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          askAnswerRecordCode: code,
        }

      }).then( (response)=> {
        if(response.data.error == 0){

          this.tableData = response.data.data.arr;

        }else if(response.data.error == 1){
          this.$message(response.data.message);
        }else{
          console.log(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });

    },


  }
}
</script>


